import template from './dashboard.html';
import controller from './dashboard.controller';
import './dashboard.scss';

let DashboardComponent = {
  bindings: {
    profiles: '<',
    closingHourObservable: '<'
  },
  template,
  controller
};

export default DashboardComponent;



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.js